import { PropsWithChildren } from "react";

import { Box, Card, CardContent, Divider, Typography } from "@mui/material";

import { LoadingOverlay } from "../loading";
import { PaymentSummaryItem, SummarySection } from "./SummarySection";
import { SummaryRow } from "./SummaryRow";

export interface PaymentSummaryPricing {
  discounts?: PaymentSummaryItem[];
  dueToday?: number;
  summary?: PaymentSummaryItem[];
  totalCost: number;
}

interface Props extends PropsWithChildren {
  formattedStartDate: string;
  loading?: boolean;
  pricing: PaymentSummaryPricing;
  mockCoverageEffectiveDate?: string;
}

export function PaymentSummary({
  children,
  formattedStartDate,
  loading,
  pricing,
}: Props) {
  return (
    <Box
      data-testid="payment-summary-card"
      sx={(theme) => ({
        minWidth: "225px",
        [theme.breakpoints.down("md")]: {
          width: "auto",
        },
      })}>
      <Box
        position="relative"
        sx={{
          marginBottom: 0,
        }}>
        <Card>
          <CardContent>
            <Box mb={2}>
              <Typography variant="subtitle1">
                Coverage effective date
              </Typography>

              <Typography variant="h5" sx={{ marginTop: 0.5 }}>
                {formattedStartDate}
              </Typography>
            </Box>

            <Divider />

            <SummarySection sectionName="Summary" items={pricing?.summary} />

            <Divider />

            <SummarySection
              sectionName="Discounts"
              items={pricing?.discounts}
            />
            {pricing && <Divider />}

            {pricing && (
              <Box mb={0} mt={3}>
                <SummaryRow
                  id="total-cost"
                  title="Total Cost"
                  value={pricing.totalCost}
                />

                {!!pricing?.dueToday && (
                  <SummaryRow
                    id="total-cost"
                    title="Due Today"
                    value={pricing.dueToday}
                  />
                )}
              </Box>
            )}
          </CardContent>
        </Card>

        {loading && <LoadingOverlay />}
        {children}
      </Box>
    </Box>
  );
}
